export default __webpack_public_path__ + "static/media/TokiRGB_green.0eb056c3.png";